import { MarketingClient } from "@/clients/marketingClient";

export class MarketingService {
    private readonly client: MarketingClient = new MarketingClient();

    public async subscribe(data: object): Promise<void> {
        await this.client.subscribe(data);
    }
}
